import { jsx as _jsx } from "react/jsx-runtime";
import Filters from '../../RaceStableList/Filters/Filters';
import { racesFilterConfig } from './RaceFiltersConfig';
import FilterDropdown from '../../../components/FilterDropdown/FilterDropdown';
import { useSearchParams } from 'react-router-dom';
const RaceFilters = ({ filter }) => {
    const [params, setParams] = useSearchParams();
    const onChange = (filter) => {
        const entries = Object.entries(filter);
        entries.forEach(([key, value]) => {
            params.set(key, String(value));
        });
        setParams(params);
    };
    return (_jsx(Filters, Object.assign({ filter: filter }, { children: racesFilterConfig.map(({ label, range, hidden, textFilterOptions, colorFilterOptions, date, location }, index) => !hidden ? (_jsx(FilterDropdown, { title: label, onChange: onChange, textFilterOptions: textFilterOptions, colorFilterOptions: colorFilterOptions, range: range, date: date, location: location }, index)) : null) })));
};
export default RaceFilters;
